"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _ButtonV = require("../ButtonV2");

var _Modal = require("../../organisms/Modal");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _notFound = _interopRequireDefault(require("../../../assets/images/defaultImages/notFound.svg"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var NotFound = function NotFound(props) {
  var className = props.className,
      code = props.code,
      message = props.message,
      details = props.details;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      className: className,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _notFound.default,
        alt: "imagen not found"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "divInfo",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
          className: "btnInfo",
          type: "pink",
          transparent: true,
          icon: _freeSolidSvgIcons.faCircleInfo,
          size: 16,
          onClick: function onClick() {
            setShowModal(true);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          className: "label-error",
          children: ["Codigo de error", /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            children: [" ", code ? code : 404, " "]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
        show: showModal,
        title: message ? message : "Error NO especificado",
        message: details ? details : "Reporta esto a TI",
        icon: "info",
        onClickBtnDefault: function onClickBtnDefault(event) {
          return setShowModal(false);
        }
      })]
    })
  });
};

exports.NotFound = NotFound;